// const API_VERSION = "1.0.0";
export const SITE_NAME = "Unity";
export const CURRENCY = "৳";
const LOCAL_ROOT_URL = process.env.REACT_APP_API_URL || "http://localhost:8001";

function isLocalUrl(url) {
    return typeof url === "string" && /localhost|127\.0\.0\.1|::1/.test(url);
}

const CONFIGURED_ROOT_URL = !isLocalUrl(LOCAL_ROOT_URL) ? LOCAL_ROOT_URL : null;

export const ROOT_URL = CONFIGURED_ROOT_URL ||
    (typeof window !== "undefined" && window.location.hostname.endsWith("fastwinbd.com")
        ? "https://api.fastwinbd.com"
        : LOCAL_ROOT_URL);

export const IMAGE_URL = `${ROOT_URL}/files`;
export const FILE_URL = `${ROOT_URL}/files`;

const API_URL = `${ROOT_URL}`;

export const UPLOAD_IMAGE_URL = `${API_URL}/admin/upload-image`;

// auth
export const LOGIN_URL = `${API_URL}/admin/login`; // Admin login endpoint (blocks BD)
export const REFRESH_TOKEN = `${API_URL}/login/refresh-token`;

// user
export const GET_ALL_USER = `${API_URL}/admin/users`;
export const GET_USER_PROFILE = `${API_URL}/admin/profile`;
export const GET_ADMIN_SESSION = `${API_URL}/admin/session`;
export const ADMIN_TWO_FACTOR_STATUS_URL = `${API_URL}/admin/two-factor/status`;
export const ADMIN_TWO_FACTOR_SETUP_URL = `${API_URL}/admin/two-factor/setup`;
export const ADMIN_TWO_FACTOR_VERIFY_URL = `${API_URL}/admin/two-factor/verify`;
export const ADMIN_TWO_FACTOR_DISABLE_URL = `${API_URL}/admin/two-factor/disable`;
export const ADMIN_LOGOUT_URL = `${API_URL}/admin/logout`;
export const ADMIN_CONTACT_CHANGE_REQUEST_URL = `${API_URL}/admin/security/contact-change/request`;
export const ADMIN_CONTACT_CHANGE_VERIFY_URL = `${API_URL}/admin/security/contact-change/verify`;
export const GET_USER_BY_ID = `${API_URL}/admin/users/id`;
export const GET_USER_DETAILS_URL = `${API_URL}/admin/users/id`;
export const CREATE_USER_URL = `${API_URL}/admin/users/create`;
export const UPDATE_USER_URL = `${API_URL}/admin/users/update`;
export const CHANGE_PASSWORD_URL = `${API_URL}/admin/change-password`;
export const DELETE_USER_URL = `${API_URL}/admin/users/delete`;
export const UPLOAD_PROFILE_IMAGE = `${API_URL}/admin/upload-image`;
export const GET_FRAUD_RISK_SUMMARY_URL = `${API_URL}/fraud-detection/admin/summary`;
export const GET_FRAUD_RISK_USER_URL = `${API_URL}/fraud-detection/admin/users`;
export const GET_ADMIN_USER_TURNOVER_URL = `${API_URL}/turnover/admin/users`;
export const ADMIN_WALLET_ADJUST_URL = `${API_URL}/wallet/admin/adjust`;
export const GAMEPLAY_HEALTH_URL = `${API_URL}/gameplay/admin/health`;
export const PROMOTION_TEST_ACCOUNTS_URL = `${API_URL}/bonus-management/admin/test-accounts`;

// Partner management
export const GET_PARTNER_DASHBOARD_URL = `${API_URL}/partners/admin/dashboard`;
export const GET_ALL_PARTNERS_URL = `${API_URL}/partners/admin/list`;
export const GET_PARTNER_USERS_URL = `${API_URL}/partners/admin/users`;
export const GET_PARTNER_USERS_BY_ID_URL = `${API_URL}/partners/admin`;
export const ADMIN_RESET_PASSWORD_URL = `${API_URL}/admin/users/admin-reset-password`;

// banner
export const GET_ALL_BANNERS = `${API_URL}/admin/banners`;
export const GET_BANNER_BY_ID = `${API_URL}/admin/banners/id`;
export const CREATE_BANNER_URL = `${API_URL}/admin/banners/create`;
export const UPDATE_BANNER_URL = `${API_URL}/admin/banners/update`;
export const DELETE_BANNER_URL = `${API_URL}/admin/banners/delete`;

// static page
export const GET_ALL_STATIC_PAGES = `${API_URL}/admin/static-page`;
export const GET_STATIC_PAGE_BY_ID = `${API_URL}/admin/static-page/id`;
export const CREATE_STATIC_PAGE_URL = `${API_URL}/admin/static-page/create`;
export const UPDATE_STATIC_PAGE_URL = `${API_URL}/admin/static-page/update`;
export const DELETE_STATIC_PAGE_URL = `${API_URL}/admin/static-page/delete`;
export const UPLOAD_STATIC_PAGE_IMAGE_URL = `${API_URL}/admin/upload-image`;

// site config
export const GET_ALL_SITE_CONFIGS = `${API_URL}/admin/site-config`;
export const GET_SITE_CONFIG_BY_ID = `${API_URL}/admin/site-config/id`;
export const CREATE_SITE_CONFIG_URL = `${API_URL}/admin/site-config/create`;
export const UPDATE_SITE_CONFIG_URL = `${API_URL}/admin/site-config/update`;
export const DELETE_SITE_CONFIG_URL = `${API_URL}/admin/site-config/delete`;
export const GET_SITE_CONFIG_CURRENT_URL = `${API_URL}/site-config/admin/current`;
export const UPDATE_SITE_CONFIG_CURRENT_URL = `${API_URL}/site-config/admin/current`;
export const PAYMENT_GATEWAY_CONFIG_URL = `${API_URL}/payment-gateway/admin/config`;
export const PAYMENT_GATEWAY_STATUS_URL = `${API_URL}/payment-gateway/status`;
export const PAYMENT_GATEWAY_VALIDATE_URL = `${API_URL}/payment-gateway/admin/validate`;
export const PAYMENT_GATEWAY_BALANCE_URL = `${API_URL}/payment-gateway/admin/balance`;
export const PAYMENT_GATEWAY_BALANCE_REFRESH_URL = `${API_URL}/payment-gateway/admin/balance/refresh`;
export const PAYMENT_GATEWAY_TRANSACTIONS_URL = `${API_URL}/payment-gateway/admin/transactions`;
export const UPLOAD_SITE_CONFIG_LOGO_URL = `${API_URL}/admin/upload-image`;

// automaticPopup
export const GET_ALL_AUTOMATICPOPUP = `${API_URL}/admin/automaticPopup`;
export const GET_AUTOMATICPOPUP_BY_ID = `${API_URL}/admin/automaticPopup/id`;
export const CREATE_AUTOMATICPOPUP_URL = `${API_URL}/admin/automaticPopup/create`;
export const UPDATE_AUTOMATICPOPUP_URL = `${API_URL}/admin/automaticPopup/update`;
export const DELETE_AUTOMATICPOPUP_URL = `${API_URL}/admin/automaticPopup/delete`;

// depositOption
export const GET_ALL_DEPOSITOPTION = `${API_URL}/admin/depositOption`;
export const GET_CURRENT_DEPOSITOPTION = `${API_URL}/depositOption/current`;
export const GET_DEPOSITOPTION_BY_ID = `${API_URL}/admin/depositOption/id`;
export const CREATE_DEPOSITOPTION_URL = `${API_URL}/admin/depositOption/create`;
export const UPDATE_CURRENT_DEPOSITOPTION_URL = `${API_URL}/depositOption/current`;
export const UPDATE_DEPOSITOPTION_URL = `${API_URL}/admin/depositOption/update`;
export const DELETE_DEPOSITOPTION_URL = `${API_URL}/admin/depositOption/delete`;

// channelType
export const GET_ALL_CHANNELTYPE = `${API_URL}/admin/channelType`;
export const GET_CHANNELTYPE_BY_ID = `${API_URL}/admin/channelType/id`;
export const CREATE_CHANNELTYPE_URL = `${API_URL}/admin/channelType/create`;
export const UPDATE_CHANNELTYPE_URL = `${API_URL}/admin/channelType/update`;
export const DELETE_CHANNELTYPE_URL = `${API_URL}/admin/channelType/delete`;

// depositRecord
export const GET_ALL_DEPOSITRECORD = `${API_URL}/admin/depositRecord`;
export const GET_DEPOSITRECORD_BY_ID = `${API_URL}/admin/depositRecord/id`;
export const CREATE_DEPOSITRECORD_URL = `${API_URL}/admin/depositRecord/create`;
export const UPDATE_DEPOSITRECORD_URL = `${API_URL}/admin/depositRecord/update`;
export const DELETE_DEPOSITRECORD_URL = `${API_URL}/admin/depositRecord/delete`;

// withdrawOption
export const GET_ALL_WITHDRAWOPTION = `${API_URL}/admin/withdrawOption`;
export const GET_CURRENT_WITHDRAWOPTION = `${API_URL}/withdrawOption/current`;
export const GET_WITHDRAWOPTION_BY_ID = `${API_URL}/admin/withdrawOption/id`;
export const CREATE_WITHDRAWOPTION_URL = `${API_URL}/admin/withdrawOption/create`;
export const UPDATE_CURRENT_WITHDRAWOPTION_URL = `${API_URL}/withdrawOption/current`;
export const UPDATE_WITHDRAWOPTION_URL = `${API_URL}/admin/withdrawOption/update`;
export const DELETE_WITHDRAWOPTION_URL = `${API_URL}/admin/withdrawOption/delete`;

// withdrawRecord
export const GET_ALL_WITHDRAWRECORD = `${API_URL}/admin/withdrawRecord`;
export const GET_WITHDRAWRECORD_BY_ID = `${API_URL}/admin/withdrawRecord/id`;
export const CREATE_WITHDRAWRECORD_URL = `${API_URL}/admin/withdrawRecord/create`;
export const UPDATE_WITHDRAWRECORD_URL = `${API_URL}/admin/withdrawRecord/update`;
export const DELETE_WITHDRAWRECORD_URL = `${API_URL}/admin/withdrawRecord/delete`;

// faqData
export const GET_ALL_FAQDATA = `${API_URL}/admin/faqData`;
export const GET_FAQDATA_BY_ID = `${API_URL}/admin/faqData/id`;
export const CREATE_FAQDATA_URL = `${API_URL}/admin/faqData/create`;
export const UPDATE_FAQDATA_URL = `${API_URL}/admin/faqData/update`;
export const DELETE_FAQDATA_URL = `${API_URL}/admin/faqData/delete`;

// Chat Template
export const GET_ALL_CHAT_TEMPLATES = `${API_URL}/chat-templates/admin/all`;
export const GET_CHAT_TEMPLATE_BY_ID = `${API_URL}/chat-templates/admin`;
export const CREATE_CHAT_TEMPLATE = `${API_URL}/chat-templates/admin/create`;
export const UPDATE_CHAT_TEMPLATE = `${API_URL}/chat-templates/admin/update`;
export const DELETE_CHAT_TEMPLATE = `${API_URL}/chat-templates/admin/delete`;

// categories
export const GET_ALL_CATEGORIES = `${API_URL}/admin/categories`;
export const GET_CATEGORIES_BY_ID = `${API_URL}/admin/categories/id`;
export const CREATE_CATEGORIES_URL = `${API_URL}/admin/categories/create`;
export const UPDATE_CATEGORIES_URL = `${API_URL}/admin/categories/update`;
export const DELETE_CATEGORIES_URL = `${API_URL}/admin/categories/delete`;

// games
// Admin listing uses /games-admin to see both active and inactive games
export const GET_ALL_GAMES = `${API_URL}/admin/games-admin`;
export const GET_GAMES_BY_ID = `${API_URL}/admin/games/id`;
export const CREATE_GAMES_URL = `${API_URL}/admin/games/create`;
export const UPDATE_GAMES_URL = `${API_URL}/admin/games/update`;
export const DELETE_GAMES_URL = `${API_URL}/admin/games/delete`;

// bet
export const GET_ALL_BET = `${API_URL}/admin/bet`;
export const GET_BET_BY_ID = `${API_URL}/admin/bet/id`;
export const CREATE_BET_URL = `${API_URL}/admin/bet/create`;
export const UPDATE_BET_URL = `${API_URL}/admin/bet/update`;
export const DELETE_BET_URL = `${API_URL}/admin/bet/delete`;

// language
export const GET_ALL_LANGUAGE = `${API_URL}/admin/language`;
export const GET_LANGUAGE_BY_ID = `${API_URL}/admin/language/id`;
export const CREATE_LANGUAGE_URL = `${API_URL}/admin/language/create`;
export const UPDATE_LANGUAGE_URL = `${API_URL}/admin/language/update`;
export const DELETE_LANGUAGE_URL = `${API_URL}/admin/language/delete`;

// all games
export const GET_AGGREGATOR_GAMES_DATA_ADMIN_URL = `${API_URL}/admin/all-games-admin?perPage=10`;
export const GET_GAME_TYPES_URL = `${API_URL}/admin/games/types`;
export const GET_PROVIDERS_BY_TYPE_URL = `${API_URL}/admin/games/types`; // Will append /{type}/providers
export const GET_GAMES_BY_TYPE_AND_PROVIDER_URL = `${API_URL}/admin/games/types`; // Will append /{type}/providers/{provider}/games

// support
export const GET_ALL_SUPPORT = `${API_URL}/admin/support`;
export const GET_SUPPORT_BY_ID = `${API_URL}/admin/support/id`;
export const CREATE_SUPPORT_URL = `${API_URL}/admin/support/create`;
export const UPDATE_SUPPORT_URL = `${API_URL}/admin/support/update`;
export const DELETE_SUPPORT_URL = `${API_URL}/admin/support/delete`;

// providers
export const GET_ALL_PROVIDERS = `${API_URL}/admin/providers`;
export const GET_PROVIDERS_BY_ID = `${API_URL}/admin/providers/id`;
export const CREATE_PROVIDERS_URL = `${API_URL}/admin/providers/create`;
export const REORDER_PROVIDERS_URL = `${API_URL}/admin/providers/reorder`;

// Admin Roles
export const GET_ALL_ADMIN_ROLES = `${API_URL}/admin/admin-roles`;
export const GET_ADMIN_ROLE_MODULES = `${API_URL}/admin/admin-roles/modules`;
export const GET_ADMIN_ROLE_OPTIONS = `${API_URL}/admin/admin-roles/options`;
export const GET_ADMIN_ROLE_BY_ID = `${API_URL}/admin/admin-roles/id`;
export const CREATE_ADMIN_ROLE_URL = `${API_URL}/admin/admin-roles/create`;
export const UPDATE_ADMIN_ROLE_URL = `${API_URL}/admin/admin-roles/update`;
export const DELETE_ADMIN_ROLE_URL = `${API_URL}/admin/admin-roles/delete`;

// Sub Admins
export const GET_ALL_SUB_ADMINS = `${API_URL}/admin/sub-admins`;
export const GET_SUB_ADMIN_BY_ID = `${API_URL}/admin/sub-admins/id`;
export const CREATE_SUB_ADMIN_URL = `${API_URL}/admin/sub-admins/create`;
export const UPDATE_SUB_ADMIN_URL = `${API_URL}/admin/sub-admins/update`;
export const DELETE_SUB_ADMIN_URL = `${API_URL}/admin/sub-admins/delete`;

// Activity Logs
export const GET_ALL_ACTIVITY_LOGS = `${API_URL}/admin/activity-logs`;

// Bonus
export const GET_ALL_BONUSES = `${API_URL}/admin/bonuses`;
export const GET_BONUS_BY_ID = `${API_URL}/admin/bonuses/id`;
export const CREATE_BONUS_URL = `${API_URL}/admin/bonuses/create`;
export const UPDATE_BONUS_URL = `${API_URL}/admin/bonuses/update`;
export const DELETE_BONUS_URL = `${API_URL}/admin/bonuses/delete`;

// Spin campaigns
export const GET_ALL_SPIN_CAMPAIGNS = `${API_URL}/admin/spin-campaigns`;
export const GET_SPIN_CAMPAIGN_BY_ID = `${API_URL}/admin/spin-campaigns/id`;
export const CREATE_SPIN_CAMPAIGN_URL = `${API_URL}/admin/spin-campaigns/create`;
export const UPDATE_SPIN_CAMPAIGN_URL = `${API_URL}/admin/spin-campaigns/update`;
export const DELETE_SPIN_CAMPAIGN_URL = `${API_URL}/admin/spin-campaigns/delete`;
export const GET_ALL_SPIN_ATTEMPTS = `${API_URL}/spin-campaigns/admin/attempts`;

// Affiliate
export const GET_ALL_AFFILIATES = `${API_URL}/admin/affiliates`;
export const GET_AFFILIATE_BY_ID = `${API_URL}/admin/affiliates/id`;
export const CREATE_AFFILIATE_URL = `${API_URL}/admin/affiliates/create`;
export const GET_REFERRAL_CONFIG_URL = `${API_URL}/referral-config/admin`;
export const UPDATE_REFERRAL_CONFIG_URL = `${API_URL}/referral-config/admin`;
export const SEARCH_USERS_URL = `${API_URL}/affiliate-referrals/admin/users/search`;
export const SEARCH_CUSTOMER_USERS_URL = `${API_URL}/affiliate-referrals/admin/users/search?scope=customer`;
export const GET_ADMIN_AFFILIATE_REFERRALS_URL = `${API_URL}/affiliate-referrals/admin/list`;
export const CREATE_ADMIN_AFFILIATE_REFERRAL_URL = `${API_URL}/affiliate-referrals/admin`;
export const TOGGLE_ADMIN_AFFILIATE_REFERRAL_URL = `${API_URL}/affiliate-referrals/admin`;
export const SYNC_ADMIN_AFFILIATE_REFERRAL_URL = `${API_URL}/affiliate-referrals/admin`;
export const GET_ADMIN_REFERRAL_BONUS_RECORDS_URL = `${API_URL}/affiliate-referrals/admin/bonus-records`;
export const GET_ADMIN_TURNOVER_SIMULATIONS_URL = `${API_URL}/affiliate-referrals/admin/turnover-simulator`;
export const CREATE_ADMIN_TURNOVER_SIMULATION_URL = `${API_URL}/affiliate-referrals/admin/turnover-simulator`;
export const GET_ADMIN_BONUS_WALLET_WITHDRAW_REQUESTS_URL = `${API_URL}/bonus-wallet/admin/withdraw-requests`;
export const APPROVE_ADMIN_BONUS_WALLET_WITHDRAW_REQUEST_URL = `${API_URL}/bonus-wallet/admin/withdraw-requests`;
export const REJECT_ADMIN_BONUS_WALLET_WITHDRAW_REQUEST_URL = `${API_URL}/bonus-wallet/admin/withdraw-requests`;

// Reports
export const GET_ALL_REPORTS = `${API_URL}/admin/reports`;
export const GET_REPORT_BY_ID = `${API_URL}/admin/reports/id`;
export const CREATE_REPORT_URL = `${API_URL}/admin/reports/create`;
export const UPDATE_PROVIDERS_URL = `${API_URL}/admin/providers/update`;
export const DELETE_PROVIDERS_URL = `${API_URL}/admin/providers/delete`;

// User Bonus
export const GET_ALL_USER_BONUSES = `${API_URL}/admin/user-bonuses`;
export const GET_USER_BONUS_BY_ID = `${API_URL}/admin/user-bonuses/id`;
export const CREATE_USER_BONUS_URL = `${API_URL}/bonus-management/admin/award`;

// Free Spins
export const GET_ALL_FREE_SPINS = `${API_URL}/admin/free-spins`;
export const GET_FREE_SPIN_BY_ID = `${API_URL}/admin/free-spins/id`;
export const CREATE_FREE_SPIN_URL = `${API_URL}/admin/free-spins/create`;

// VIP Config
export const GET_ALL_VIP_CONFIGS = `${API_URL}/admin/vip-configs`;
export const GET_VIP_CONFIG_BY_ID = `${API_URL}/admin/vip-configs/id`;
export const CREATE_VIP_CONFIG_URL = `${API_URL}/admin/vip-configs/create`;

// Bonus Transactions
export const GET_ALL_BONUS_TRANSACTIONS = `${API_URL}/admin/bonus-transactions`;

// Bonus Management (admin endpoints)
export const ADMIN_AWARD_BONUS_URL = `${API_URL}/bonus-management/admin/award`;
export const ADMIN_AWARD_FREE_SPIN_URL = `${API_URL}/bonus-management/admin/free-spin`;
export const ADMIN_EXPIRE_BONUS_URL = `${API_URL}/bonus-management/admin/expire`;

// Bonus Limits Config
export const GET_ALL_BONUS_LIMITS_CONFIG = `${API_URL}/admin/bonus-limits-config`;
export const CREATE_BONUS_LIMITS_CONFIG_URL = `${API_URL}/admin/bonus-limits-config`;
export const UPDATE_BONUS_LIMITS_CONFIG_URL = `${API_URL}/admin/bonus-limits-config`;
export const DELETE_BONUS_LIMITS_CONFIG_URL = `${API_URL}/admin/bonus-limits-config`;

// Affiliate Commission
export const GET_ALL_AFFILIATE_COMMISSIONS = `${API_URL}/admin/affiliate-commissions`;
export const APPROVE_COMMISSION_URL = `${API_URL}/bonus-management/admin/commission`;
export const PAY_COMMISSION_URL = `${API_URL}/bonus-management/admin/commission`;

// Bonus Report
export const GET_BONUS_REPORT_URL = `${API_URL}/bonus-management/admin/report`;

// CONSTANT_EXPORTS_AREA
export const ACCESS_TOKEN = "unity-token";
export const PROFILE = "unity-profile";
export const ORDER_STATE_COLOR = {
    INITIATED: "",
    SUPPLIER_ACCEPTED: "cyan",
    DELIVERY_MAN_PICKED: "blue",
    COMPLETED: "green",
    CANCELED: "red"
};
export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
};
export const COMPANY = {
    name: "URELAA",
    address: "Dhaka Division, Bangladesh"
};
export const BACK_BUTTON_COLOR = "#3390FF";
// end
